var $2dd1894272e6d5f5$exports = {};
$2dd1894272e6d5f5$exports = {
    "removeButtonLabel": `Rimuovi`,
    "removeDescription": `Premi Elimina per rimuovere il tag.`
};


export {$2dd1894272e6d5f5$exports as default};
//# sourceMappingURL=it-IT.mjs.map
